export class ApplicationImpoundsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getImpounds({ applicationId }) {
    return this.#http.get(`/application/${applicationId}/impound`);
  }

  async editImpounds({ applicationId, ...body }) {
    return this.#http.put(`/application/${applicationId}/impound/v2`, body);
  }
}
